import { useState } from "react";
import { motion } from "framer-motion";
import { Send, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("कृपया सही ईमेल दर्ज करें");
      return;
    }
    setBusy(true);
    try {
      const res = await subscribeNewsletter(email);
      setDone(true);
      toast.success(res.already ? "आप पहले से सब्सक्राइब हैं!" : "सब्सक्रिप्शन सफल!");
    } catch {
      toast.error("कुछ गलत हो गया, पुनः प्रयास करें");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-16" data-testid="newsletter-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="force-dark relative bg-[#FFD400] px-6 sm:px-12 py-12 sm:py-16 overflow-hidden"
      >
        <span className="absolute -right-6 -bottom-10 font-display text-[10rem] leading-none text-[#0D0D10]/10 select-none pointer-events-none">ख</span>
        <div className="relative max-w-2xl">
          <span className="font-mono-meta text-[11px] font-semibold uppercase tracking-[0.3em] text-[#0D0D10]/70">खबरिक न्यूज़लेटर</span>
          <h2 className="font-display text-3xl sm:text-4xl text-[#0D0D10] mt-3">हर सुबह की बड़ी खबरें, सीधे आपके इनबॉक्स में</h2>
          {done ? (
            <p className="mt-6 flex items-center gap-2 text-[#0D0D10] font-semibold" data-testid="newsletter-success">
              <MailCheck size={18} /> धन्यवाद! आप सब्सक्राइब हो चुके हैं।
            </p>
          ) : (
            <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md">
              <input
                data-testid="newsletter-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="आपका ईमेल पता"
                className="flex-1 bg-[#0D0D10] text-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D0D10] placeholder:text-slate-500"
              />
              <button
                type="submit"
                disabled={busy}
                data-testid="newsletter-subscribe-button"
                className="flex items-center justify-center gap-2 bg-[#0D0D10] text-[#FFD400] px-6 py-3 text-sm font-bold hover:bg-black transition-colors disabled:opacity-60"
              >
                <Send size={14} /> {busy ? "..." : "सब्सक्राइब करें"}
              </button>
            </form>
          )}
        </div>
      </motion.div>
    </section>
  );
}
